import MuiInputAdornment from '@mui/material/InputAdornment';
import MuiTextField from '@mui/material/TextField';
import styled from 'styled-components';
export const InputAdornment = styled(MuiInputAdornment)(({ theme, }) => ({}));
export const InputStyled = styled(MuiTextField).attrs((({ theme, InputProps, }) => {
    var _a, _b;
    return ({
        InputProps: {
            style: {
                backgroundColor: (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.background) === null || _b === void 0 ? void 0 : _b.default,
                ...InputProps === null || InputProps === void 0 ? void 0 : InputProps.style,
            },
        },
    });
}))(({ theme, disabled, error, }) => {
    var _a;
    return ({
        fieldset: {
            borderWidth: '1px !important',
        },
        ...disabled && {
            fieldset: {
                borderColor: 'transparent !important',
                backgroundColor: (_a = theme === null || theme === void 0 ? void 0 : theme.neutrals) === null || _a === void 0 ? void 0 : _a[100],
                legend: {
                    background: theme === null || theme === void 0 ? void 0 : theme.palette.background.default,
                    visibility: 'visible',
                    borderRadius: '4px',
                },
            },
            [`${InputAdornment}`]: {
                color: theme === null || theme === void 0 ? void 0 : theme.palette.text.disabled,
            },
        },
        ...error && {
            [`${HelperText}`]: {
                color: theme === null || theme === void 0 ? void 0 : theme.palette.error.main,
            },
        },
        [`${HelperStyled}`]: {
            color: theme === null || theme === void 0 ? void 0 : theme.palette.text.disabled,
        },
    });
});
export const HelperStyled = styled.span(({ theme, }) => ({
    ...theme === null || theme === void 0 ? void 0 : theme.typography.body2,
    display: 'flex',
    justifyContent: 'space-between',
    gap: '10px',
    lineHeight: 'unset',
    [`${HelperText}, ${Counter}`]: {
        fontSize: '85%',
    },
}));
export const HelperText = styled.span(({ theme, }) => ({}));
export const Counter = styled.span(({ theme, focused, }) => ({
    position: 'relative',
    transition: 'all 200ms',
    flexShrink: 0,
    opacity: 0,
    top: '-1.5em',
    zIndex: -1,
    userSelect: 'none',
    ...focused && {
        opacity: 1,
        top: 0,
    },
}));
//# sourceMappingURL=Input.styles.js.map